/**
 * App Configuration
 * @apal/web-apal
 */

export const appConfig = {
  name: "APAL",
  fullName: "Agency Portal Admin Layer",
  themeColor: "#1e40af",
  version: "0.0.0",
} as const;
